<template>
    <div class="video_h5D" v-if='cur_data.chapter_type == 1'>
        <Header  v-if="ish5R=='video_d'">
            <h4><span>{{cur_data.chapter_title}}</span></h4>
        </Header>
       <aliPlayer ></aliPlayer>
       <div class="test_submit">
            <div class="submit_done">
              <a class="sub" :class="{cur:cur_data.idx==1}" v-show="cur_data.chapter_id!=firstChapterId" @click="checkChapter('prev',cur_chap_index,cur_part_index)">{{$t('prevChapter')}}</a>
              <a class="sub" :class="{cur:cur_data.idx==1}" v-show="cur_data.chapter_id==firstChapterId" @click="lookHeadVideo">{{$t('prevChapter')}}</a>
              <a class="next" v-show="cur_data.chapter_id!=lastChapterId" @click="checkChapter('next',cur_chap_index,cur_part_index)">{{$t('nextChapter')}}</a>
              <a class="next" v-show="cur_data.chapter_id==lastChapterId" @click="lookFootVideo">{{$t('nextChapter')}}</a>
            </div>
        </div>
    </div>
</template>
<script>
import aliPlayer from 'components/aliPlayer'
import Header from 'components/H5/Header.vue'
import mixins from 'components/H5/mixins/compon.js'

export default {
  name: 'Video',
  mixins: [mixins],
  data () {
    return {
      source: '', // 视频地址
      ish5R: '', // 横竖屏判断
      lastChapterId: '', // 最后一章节
      firstChapterId: '', // 第一章节
      checkedChapterType: '' // 切换后章节id
    }
  },
  computed: {
    cur_data () {
      return this.$store.state.cur_data
    },
    cur_chap_index () {
      return this.$store.state.currentChapterIndex
    },
    next_data () {
      return this.$store.state.next_data
    },
    cur_part_index () {
      return this.$store.state.currentPartIndex
    },
    video_finished () {
      return this.$store.state.video_finished
    }
  },
  created () {
    this.ish5R = this.$route.name
    this.lastChapterId = JSON.parse(JSON.stringify(this.data)).part_list[ this.data.part_list.length - 1].chapter_list.pop().chapter_id
    this.firstChapterId = this.data.part_list[0].chapter_list[0].chapter_id
    this.source = this.cur_data.file_path[0]
    this.$store.commit('video_url', this.source)

    /* 存小节学习状态 */
    // this.setLessonLocation(this.cur_part_index,this.cur_chap_index)
  },
  methods: {

  },
  watch: {
    video_finished () {
      if (this.$store.state.video_finished) {
        if (this.next_data.chapter_type == 1) {
          this.source = this.next_data.file_path[0]
          this.$store.commit('video_url', this.source)
        }
        let curPartIndex = Number(this.cur_part_index)
        let curChapIndex = Number(this.cur_chap_index)
        let nexPartIndex = curPartIndex
        let nexChapIndex = curChapIndex
        if (curChapIndex < this.data.part_list[curPartIndex].chapter_list.length - 1) {
          curChapIndex = curChapIndex + 1
        } else if (curPartIndex < this.data.part_list.length - 1) {
          curPartIndex = curPartIndex + 1
          curChapIndex = 0
        } else {
          this.lookFootVideo()
        }
        if (curChapIndex < this.data.part_list[curPartIndex].chapter_list.length - 1) {
          nexPartIndex = curPartIndex
          nexChapIndex = curChapIndex + 1
        } else if (curPartIndex < this.data.part_list.length - 1) {
          nexPartIndex = curPartIndex + 1
          nexChapIndex = 0
        }
        this.$store.commit('cur_data', this.next_data)
        this.$store.commit('currentChapterIndex', curChapIndex)
        this.$store.commit('currentPartIndex', curPartIndex)
        this.$store.commit('next_data', this.data.part_list[nexPartIndex].chapter_list[nexChapIndex])

        if (this.cur_data.chapter_type == 1) { // 视频类型
          this.source = this.cur_data.file_path[0]
          this.$store.commit('video_url', this.source)
          this.$router.push('/h5Dindex/video')
        } else if (this.cur_data.chapter_type == 2) { // 小测验
          // this.$store.commit('quiz_type', this.next_data.chapter_content.quiz_type);
          this.$router.push('/h5Dindex/test')
        } else {
          // 图文 4
          this.$router.push('/h5Dindex/tuwen')
        }
      }
    },
    cur_data () {
      if (this.cur_data.file_path) {
        this.source = this.cur_data.file_path[0]
        this.$store.commit('video_url', this.source)
      }
    }

  },
  components: {
    aliPlayer,
    Header
  }
}
</script>
<style lang="less" scoped>
    .video_h5D {
       /*  padding:.2rem 1.2rem;
        .aliplayer {
            height: calc(100vh - 2.2rem);
        } */
        font-size:.26rem;
        .test_submit {
        padding:0.8rem 0.46rem 0.4rem;
        height: 2.2rem;
        box-sizing: border-box;
        .unsubmit {
          /*margin: 40px 0 20px;*/
          img {
            width: 0.22rem;
            height: 0.4rem;
            margin:0.28rem 0.24rem;
          }
          .sub,.next {
            display: inline-block;
            width:0.68rem;
            height:0.96rem;
            border:1px solid rgba(169, 174, 175, 1);
            border-radius:0.06rem;
            margin-right: 0.2rem;
            vertical-align: middle;
            &.yc {
              visibility: hidden;
            }
          }
          .next {
            float: right;
            margin-right: 0;
          }
          .submit {
            display: inline-block;
            width:4.7rem;
            height:1rem;
            background-color: @basic-color;
            border-radius:0.06rem;
            margin: 0 auto;
            font-size:0.3rem;
            color: #fff;
            text-align: center;
            line-height: 1rem;
            vertical-align: middle;
          }
        }
        .submit_done {
          .sub {
            color: @basic-color;
            background-color: #fff;
          }
          .next {
            color: @basic-color;
            background-color: #fff;
            float: right;
          }
          .sub,.next {
            width:3.12rem;
            border:1px solid @basic-color;
            border-radius:0.06rem;
            text-align: center;
            line-height: .78rem;
            display: inline-block;
            font-size: 0.32rem;
            &.cur {
              border:1px solid #ccc;
              color: #ccc;
              opacity:.8;
            }
          }

        }
      }

    }
</style>
